/**
 * QuizSelectionSection.js
 * Written by: Alex Kasemir
 */
import React, { Component } from 'react';
// import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import CategorySelection from 'containers/CategorySelection';
import SubCategoryDisplay from 'containers/SubCategoryDisplay';
import UserSummaryBanner from 'containers/UserSummaryBanner';

import {
  QuizSelectionSectionContainer,
  CategoryHeader,
  SelectionContainer,
} from './QuizSelectionSection.styles';

/**
 * View you submitted questions
 *
 */
export class QuizSelectionSection extends Component {
  render() {
    return (
      <QuizSelectionSectionContainer id="quiz-selection">
        <CategoryHeader>
          Select a Category
        </CategoryHeader>
        <SelectionContainer>
          <CategorySelection />
          <SubCategoryDisplay />
        </SelectionContainer>
        <UserSummaryBanner />
      </QuizSelectionSectionContainer>
    );
  }
}

QuizSelectionSection.propTypes = {
};

export default connect(() => {
  return {
  };
}, {})(QuizSelectionSection);
